import { buildApiUrl, API_ENDPOINTS, apiRequest } from '../config/api.js'

export const clocksApi = {
  async getClocks(userId) {
    const url = buildApiUrl(API_ENDPOINTS.CLOCKS.BY_USER(userId))
    const response = await apiRequest(url)
    return response.data
  },

  async toggleClock(userId, data = {}) {
    const url = buildApiUrl(API_ENDPOINTS.CLOCKS.TOGGLE(userId))
    return apiRequest(url, {
      method: 'POST',
      body: JSON.stringify(data),
    })
  },
}